<script setup lang="ts">
import type { NavbarItem } from '.';

const { item } = defineProps<{ item: NavbarItem; dropdownOpen?: boolean }>();
const emit = defineEmits<{ dropdownOpen: []; dropdownClose: [] }>();

function toggleDropdown() {
  if (item.dropdown) {
    emit('dropdownOpen');
  } else {
    emit('dropdownClose');
  }
}
</script>

<template>
  <li>
    <AppLinkShellText
      v-if="item.dropdown"
      size="sm"
      :class="{ 'text-client-orange': dropdownOpen }"
      class="hover:text-client-orange group cursor-pointer transition-colors"
      @mouseenter="toggleDropdown"
    >
      {{ item.label }}
      <template #icon>
        <SVGChevron
          v-if="item.dropdown"
          :class="{ 'rotate-180': dropdownOpen }"
          class="size-3 transition-transform group-hover:rotate-180"
        />
      </template>
    </AppLinkShellText>
    <AppLink
      v-else
      type="text"
      :to="item.link"
      :opts="{ size: 'sm' }"
      :class="{ 'text-client-orange': dropdownOpen }"
      class="hover:text-client-orange group transition-colors"
      @mouseenter="toggleDropdown"
    >
      {{ item.label }}
    </AppLink>
  </li>
</template>
